import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Col } from 'antd'

const SortableProductItem = ({ id, children, disableDragAndDrop = false }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled: disableDragAndDrop })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <Col
      ref={setNodeRef}
      style={style}
      className="card-item"
      lg={8}
      md={12}
      sm={24}
      xl={8}
      xs={24}
      xxl={6}
      {...(!disableDragAndDrop ? { ...attributes, ...listeners } : {})}
    >
      <div style={{ visibility: isDragging ? 'hidden' : 'visible' }}>
        {children({ dragHandleProps: {} })}
      </div>
    </Col>
  )
}

export default SortableProductItem
